<template>
    <div class="cart_combinations">
        <label class="form-label mb-2">{{ __t('CART_PRODUCTS_RULES') }}</label>

        <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed mb-4 mt-4" v-on:click="addCartRow">
            <span  class="fal  fa-eject mr-1"></span>
            {{__t('ADD_ROW')}}
        </button>

        <div v-for="(row, index) in action_cart_rules" :key="row.uid" class="cart_comb_row mb-4 p-3 bg-white shadow-sm rounded">

            <div class="is_exclude">
                <yes_no
                    :key="row.is_exclude"
                    :title="__t('is_exclude')"
                    v-model="row.is_exclude"
                >

                </yes_no>
                -
            </div>

            <div class="form-group products_in_list mb-2">

                <v-select
                          v-model="row.product"
                          :filterable="false"
                          label="title"
                          :options=products_search_options
                          @search="onSearch"
                          class="imc_reasons"
                          :key="row.uid"
                          @input="emitUpdate">
                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                            <div>
                                <small >{{option.uniq_id}}</small>

                                <small v-if="option.hasOwnProperty('prov_type')" >
                                    {{option.prov_type}}
                                </small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>

            <div class="form-group mb-2">
                <label>{{ __t('QTY') }}</label>
                <input type="number" class="form-control" min="1" @change="emitUpdate" v-model.number="row.qty" />
            </div>

            <div class="d-flex justify-content-between align-items-center">
                <button class="btn btn-sm btn-outline-danger" @click="removeCartRow(index)">
                    <i class="fal fa-minus"></i>
                </button>
                <button class="btn btn-sm btn-outline-success" @click="addCartRow">
                    <i class="fal fa-plus"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import vSelect from 'vue-select';
import Yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "action_cart_rule",
    props: {
        action: {
            type: Object,
            required: true
        }
    },
    components: {
        Yes_no,
        vSelect
    },

    data() {
        return {
            action_cart_rules: [],
            products_search: [],
            product_list: []
        };
    },
    mounted() {
        if(this.action.hasOwnProperty("action_cart_rules")) {
            this.action.action_cart_rules.map(item => {
                this.action_cart_rules.push(item);
            });
        }
    },
    methods: {

        onSearch(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },

        emitUpdate() {
            this.$emit('on_change_attribute', 'action_cart_rules',this.action_cart_rules);
        },

        async search(loading, search) {
            this.products_search = [];
            await api.post('/internal/v1/catalog/products', {
                "filter": {
                    "search": search
                },
                "list": {
                    "limit": 100,
                }
            }).then(({data}) => {
                loading(false);
                if (data.status === "operation_success") {
                    this.products_search = data.data;
                }
            }).catch(({response}) => {
                loading(false);
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        loadInitial() {

        },

        addCartRow() {
            this.action_cart_rules.push({
                uid: uuidv4(),
                is_exclude : false,
                product: null,
                qty: 1
            });
            this.emitUpdate();
        },

        removeCartRow(index) {
            this.action_cart_rules.splice(index, 1);
            this.emitUpdate();
        },

        getRules() {
            return this.action_cart_rules.map(row => ({
                product_id: row.product,
                qty: row.qty
            }));
        }
    },

    computed : {

        products_search_options () {
            return this.products_search.map(item => {
                return {
                    "id" : item.id,
                    "title" : item.title,
                    'uniq_id' : item.uniq_id,
                    'prov_type' : item.prov_type
                }
            });
        }
    }


}
</script>

<style scoped>
.cart_comb_row {

}
</style>
